import { useState } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '@/store'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { useUserTimezone } from '@/hooks/useUserTimezone'
import { todayISO } from './reminderTime'
import { ReminderPanel } from './ReminderPanel'
import { StickyNoteIcon } from './StickyNoteIcon'
import { useReminderActions } from './useReminderActions'

/** 角标数：今天及之前到期、仍 open 的提醒。铃铛与手机顶栏「更多」上的红点共用这一个口径。 */
export function useReminderBadgeCount(): number {
  const tz = useUserTimezone()
  const items = useSelector((s: RootState) => s.reminders.items)
  const today = todayISO(tz)
  return items.filter((r) => r.status === 'open' && r.dueDate <= today).length
}

export function ReminderBell() {
  const [open, setOpen] = useState(false)
  const tz = useUserTimezone()
  const items = useSelector((s: RootState) => s.reminders.items)
  const loadFailed = useSelector((s: RootState) => !!s.reminders.error)
  const actions = useReminderActions(tz)

  const badge = useReminderBadgeCount()

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button title="My Reminders" className="note-entry relative grid h-9 w-9 place-items-center rounded-md hover:bg-accent"
          style={{ background: open ? 'rgba(245, 158, 11, .18)' : 'transparent', boxShadow: open ? 'inset 0 0 0 1px #FDE68A' : 'none' }}>
          <StickyNoteIcon lit />
          {badge > 0 && (
            <span style={{
              position: 'absolute', top: -2, right: -3, minWidth: 15, height: 14, padding: '0 4px',
              display: 'grid', placeItems: 'center', background: '#F59E0B', color: '#fff',
              fontSize: 9, fontWeight: 800, borderRadius: 99, border: '1.5px solid hsl(var(--background))', lineHeight: 1,
            }}>{badge}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="p-0 border-0 bg-transparent shadow-none w-auto"
        onEscapeKeyDown={(e) => {
          // 行内编辑时 Esc 只取消编辑,不关整个 popover(Radix 在 document capture 阶段监听,行内 preventDefault 拦不到)
          // 只匹配编辑态 input 本身:焦点在行内其他按钮/深链 chip 上时 Esc 仍应正常关闭 popover
          if ((e.target as HTMLElement | null)?.classList?.contains('rem-edit-input')) e.preventDefault()
        }}>
        <ReminderPanel reminders={items} tz={tz} defaultColor="yellow" loadFailed={loadFailed}
          actions={{ ...actions }} onClose={() => setOpen(false)} onNavigate={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  )
}
